import api from "./api";

const route = "/instructors";

export default {
  getCoaches: () => api.get(route),
  getSingleCoach: (instructor_id) => api.get(`${route}/${instructor_id}`),
  postCoach: (coach) => api.post(route, { ...coach }),
  putCoach: (coach) => api.put(route, { ...coach }),
  deleteCoach: (instructor_id) => api.delete(`${route}/${instructor_id}`),
};
